import React, {Fragment} from 'react'
import PastReports from './PastReports';
import RecentReports from './RecentReports';

export default function InspectionReports(props){

    return(<>

        <header class="section-header mb-7">
            <h2><strong>Inspection Reports</strong></h2>
        </header>

        <RecentReports {...props} />

        <PastReports {...props} />
        
   </>)

}